import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY

export const getSolicitudesReclutamiento = async (fecha_inicio, fecha_fin) => {
    const params = {
        fecha_inicio: fecha_inicio,
        fecha_fin: fecha_fin
    }
    try {
        const result = await api.get(`${urlApi}/talentoHumano/solicitudes-reclutamiento`, { params });
        return result.data;
    }
    catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
}
export const verificar = async (id, estado) => {
    const params = {
        id: id,
        estado: estado
    }
    try {
        const result = await api.patch(`${urlApi}/talentoHumano/solicitudes-reclutamiento/verificar`, params );
        return 'verificado';
    }
    catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
}